/* eslint-disable camelcase */
import React from "react";
import { ReactComponent as RainIcon } from "./../../images/svg/rain.svg";
import { ReactComponent as DewIcon } from "./../../images/svg/dew.svg";
import { ReactComponent as FrostIcon } from "./../../images/svg/frost.svg";
import { ReactComponent as WindIcon } from "./../../images/svg/wind.svg";

const mapCodeToIcon = (reason) => {
  var icon = "";
  switch (reason) {
    case "RAIN": // RAIN
      icon = <RainIcon />;
      break;
    case "WIND": // WIND
      icon = <WindIcon />;
      break;
    case "DEW": // DEW
      icon = <DewIcon />;
      break;
    case "FROST":
      icon = <FrostIcon />;
      break;
    default:
      icon = null;
  }
  return icon;
};

const pad = (number) => {
  var s = String(number);
  while (s.length < 2) {
    s = "0" + s;
  }
  return s;
};

const SprayingForecastHour = ({ hour, days, sprayingforecast }) => {
  var hour_in_day = hour;

  hour = pad(hour_in_day) + ":00";
  var forecasts = days.map(function (day, i) {
    var date_time = day + "T" + hour;
    if (sprayingforecast[date_time]) {
      return (
        <td className={sprayingforecast[date_time].advice} key={i}>
          <div>{mapCodeToIcon(sprayingforecast[date_time].reason)}</div>
        </td>
      );
    } else {
      return (
        <td className="NO_DATA" key={i}>
          <div></div>
        </td>
      );
    }
  });
  return (
    <tr>
      <td>{hour}</td>
      {forecasts}
    </tr>
  );
};

export default SprayingForecastHour;
